import 'jquery-cookie';

export default function getTreatment(name) {
  if (!SS.serverBootstrap.flags) {
    return false;
  }
  return SS.serverBootstrap.flags[name];
}

// gr_mui_auth
export function shouldMUIAuth() {
  return getTreatment('gr_mui_auth') == 'on';
}

// gr_emb_sup_loh
export function shouldRenderEmbeddedSignUpLOH() {
  return getTreatment('gr_emb_sup_loh') == 'on';
}

export function shouldRenderTranscriptsTab() {
  return getTreatment('learning_transcripts_tab') === 'on';
}

export function shouldRenderTranscripts() {
  return getTreatment('learning_user_transcripts') === 'on';
}

export function shouldRenderPictureInPicture() {
  return getTreatment('learning_user_pip') === 'on';
}

// disc_teacher_popover
export function hideTeacherPopover() {
  return getTreatment('disc_teacher_popover') === 'hide';
}

export function shouldShowTranscriptsEditorForTeachers() {
  return getTreatment('learning_transcripts_editor_for_teachers') === 'on';
}

export function shouldRenderReactR4YRow() {
  return getTreatment('disc_react_r4y_row') === 'on';
}

export function audioOnlyClassesAreEnabled() {
  return getTreatment('lx_audio_only_classes') === 'on';
}

export function captionsByDefaultTestIsEnabled() {
  return getTreatment('lx_captions_test') === 'on';
}

export function autoplayDisabledTestIsActive() {
  return getTreatment('lx_disable_autoplay_test') === 'on';
}

export function autoplayMutedTestIsActive() {
  return getTreatment('lx_disable_autoplay_test') === 'on_muted_audio';
}


// sft_bk_invite
// sft_bk_resend
// sft_bk_export
// sft_bk_remove
export function shouldRenderSftDropdown() {
  return getTreatment('sft_bk_invite') === 'on'
    || getTreatment('sft_bk_resend') === 'on'
    || getTreatment('sft_bk_export') === 'on'
    || getTreatment('sft_bk_remove') === 'on';
}

export function showTranscriptsTooltip() {
  return getTreatment('lx_new_feature_tooltip_transcripts') === 'on';
}

export function shouldRenderClassCreatorUpdates() {
  return getTreatment('lx_cc_sqs') === 'on';
}

export function shouldRenderLihVideoPromo() {
  return getTreatment('disc_lih_video_promo') === 'on';
}

export function shouldRenderMuiBanner() {
  return getTreatment('disc_mui_promo_banner') === 'on';
}

export function shouldRenderGqlProject() {
  return getTreatment('gr_gql_project') === 'on';
}

// disc_onboard_selection
export function shoudShowOnboardingSelection() {
  return getTreatment('disc_onboard_selection') === 'on';
}